module.exports = __webpack_public_path__ + "img/3.00ef6e72.jpg";